export enum CredentialDisplayMode {
  Login = 'login',
  Register = 'register',
  ForgotPassword = 'forgot-password',
  TwoFactor = 'two-factor',
}
